import React from "react";

function PICCardSkeleton() {
	return (
		<div className="w-[276px] p-4 pt-0 shadow-md border border-gray-300 rounded-md animate-pulse">
			<div className="flex items-center justify-center">
				<div className="h-[26px] w-24 bg-gray-200 rounded-b" />
			</div>

			<div className="w-[242px] h-[212px] bg-gray-200 rounded-md mt-2" />

			<div className="h-[22px] w-3/4 bg-gray-200 rounded mt-3" />

			<div className="flex items-center gap-x-2 mt-2">
				<div className="h-4 w-4 bg-gray-200 rounded shrink-0" />
				<div className="h-3.5 w-2/3 bg-gray-200 rounded" />
			</div>

			<div className="flex items-center gap-x-2 mt-2">
				<div className="h-4 w-4 bg-gray-200 rounded shrink-0" />
				<div className="h-3.5 w-1/2 bg-gray-200 rounded" />
			</div>
		</div>
	);
}

export default PICCardSkeleton;
